import { RefObject } from 'react';
import { HighChartsWrapper } from '../../../../components/HighCharts/HighChartsLibrary';
import { IRouterWithIntl } from '../../../../utils';
import { TythonColumnsEnum } from '../../@data/store/schema/ColumnsEnum';
import { ICustomCalenderDateRange } from '../../components/CustomCalender/CustomCalender.types';
import { FormatMessageFuncType } from '../../utils/intlHelper';
import { IMetadataElement, IReportsMetadata, PubCenterReportingDataRow, TythonReportingDataRow } from '../@data/store/schema';
import { IMetricMarkerProps } from '../MetricMarker/MetricMarker.types';
import { IActiveFilter } from '../ReportDetailsPage/ActionBar/ActionBar';

export interface IReportCardProps extends IRouterWithIntl {
  title: string;
  type: ReportCardType;
  allowedChartTypes: IChartButton[];
  defaultColumns: TythonColumnsEnum[];
  defaultMetrics: TythonColumnsEnum[];
  enableHideChartsButton?: boolean;
  hasMinimumBreakdown?: boolean;
  reportData?: TythonReportingDataRow[] | PubCenterReportingDataRow[];
  summaryData?: TythonReportingDataRow[] | PubCenterReportingDataRow[];
  reportDetailedData?: TythonReportingDataRow[] | PubCenterReportingDataRow[];
  isSummaryDataLoaded?: boolean;
  reportMetadata?: IReportsMetadata;
  defaultChartGrain?: ChartGrain;
  allowedChartGrains: IMetadataElement[];
  showChartGrains?: boolean;
  showMetricsMarkers?: boolean;
  dataMetrics: IReportDataMetrics;
  mainDimension?: string;
  dateDimension: string;
  showDetailsReportLink: boolean;
  dateRange: ICustomCalenderDateRange;
  filters: IActiveFilter[];
  isDetailedView: boolean;
  onChartGrainChanged?: (grain: ChartGrain) => void;
  onSelectedMetricChanged?: (metric: string) => void;
  onActiveMetricsChanged?: (activeMetrics: ActiveMetrics) => void;
  onBreakDownChanged?: (newBreakdown: string[]) => void;
  onViewReportClick?: () => void;
  reportCardRef: RefObject<HTMLDivElement>;
  legend?: boolean;
  showDateTopBar?: boolean;
  showExportButton?: boolean;
  hideCommandBar?: boolean;
  hideChart?: boolean;
  searchQuery?: string;
  isPubCenterChart?: boolean;
  reportType?: string;
  extraDimensions?: TythonColumnsEnum[];
  showDropdownMetrics?: boolean;
  setDefaultSelectedColumns?: React.Dispatch<React.SetStateAction<string[]>>;
}

export interface IChartButton {
  chartType: ChartTypes;
  disabled: boolean;
  iconName: string;
  dataTestId?: string;
}

export interface IReportOptions {
  mainDimension: string;
}

export interface IReportDataMetrics {
  chartDataMetrics: string;
}
export interface IChartsOptions {
  currentChartType: ChartTypes;
  currentChartGrain: ChartGrain;
  reportData: TythonReportingDataRow[] | PubCenterReportingDataRow[];
  mainDimension?: IMetadataElement;
  selectedMetric: IMetadataElement;
  chartComponentRef: React.RefObject<HighChartsWrapper.RefObject>;
  mapChartComponentRef: React.RefObject<HighChartsWrapper.RefObject>;
  activeMetrics: ActiveMetrics;
  dateDimension: string;
  countryCodeDimension?: string;
  formatMessage: FormatMessageFuncType;
  legend?: boolean;
  isPubCenterChart?: boolean;
  extraDimensions?: IMetadataElement[];
}
export interface IReportDetailsPageParams {
  type: ReportCardType;
}

export enum ChartTypes {
  DONUT = 'Donut',
  BAR = 'Bar',
  GRID = 'Grid',
  LINE = 'Line',
  MAP = 'Map',
}

export enum ChartGrain {
  NONE = 'None',
  HOURLY = 'Hour',
  DAILY = 'Day',
  WEEKLY = 'Week',
  MONTHLY = 'Month',
  YEARLY = 'Year',
  MONTH_AND_YEAR = 'MonthAndYear',
}
export enum ReportCardType {
  PERFORMANCE = 'performance',
  ACCOUNT = 'account',
  ADUNIT = 'adunit',
  SITE = 'site',
  COUNTRY = 'country',
  MEDIATION = 'mediation',
  CUSTOM = 'custom',
  SUMMARY = 'summary',
  TYPE_TAG = 'typetag',
  PTQs = 'ptqs',
  PTQSSnapshot = 'ptqssnapshot',
  distributionV2 = 'distributionV2',
  DistributionPartnerTagV2 = 'DistributionPartnerTagV2',
  DistributionPTQS = 'DistributionPTQS',
  DistributionPTQSSnapshot = 'DistributionPTQSSnapshot',
  StartDistributionNativeAdsInFeedsAndHeadlines = 'StartDistributionNativeAdsInFeedsAndHeadlines',
  StartDistributionContent = 'StartDistributionContent',
}

export type ActiveMetrics = Record<string, IMetricMarkerProps>;
